export class changePasswordUser
{
    public Username:string;
    public currentPassword:string;
    public newPassword:string;
}